import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { ButtonWithIcon } from '@els/els-react--button';

function DocumentAbstract({ abstractText, closeClick }) {
  return (
    <div className="result-detail-panel result-detail-abstract">
      <div className="result-detail-panel-wrapper u-els-padding u-els-margin-right-2x">
        <h4>Abstract</h4>
        <InnerHTML
          tag="p"
          className="result-detail-block u-els-font-size-caption u-els-line-height-default u-els-margin-top-1o2"
          html={abstractText}
        />
        <ButtonWithIcon
          type="link"
          iconOnly
          sprite="Close"
          className="sub-menu-close e2e-close"
          data-automationId="sub-menu-close"
          onClick={closeClick}>
          close
        </ButtonWithIcon>
      </div>
    </div>
  );
}

DocumentAbstract.propTypes = {
  abstractText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentAbstract;
